<template>
  <div class="cancel-subscription" role="alert">
    <div v-if="isLoading" class="cancel-subscription__wrapper">
      <div class="cancel-subscription__loader">
        <ActionLoader />
      </div>
    </div>
    <template v-else>
      <InformCancellation
        v-if="currentStep === steps[0]"
        :planExpiryDate="planExpiryDate"
        @close-cancel-subscription-modal="
          $emit('close-cancel-subscription-modal')
        "
        @handle-confirm-click="currentStep = steps[1]"
      />
      <ConfirmCancellation
        v-if="currentStep === steps[1]"
        :survey="cancellationFields"
        :subscriptionId="subscription.id"
        @close-cancel-subscription-modal="
          $emit('close-cancel-subscription-modal')
        "
        @handle-confirm-click="handleCancelSubscription"
      />
      <CancellationSuccess
        v-if="currentStep === steps[steps.length - 1]"
        :planExpiryDate="planExpiryDate"
        @close-cancel-subscription-modal="
          $emit('close-cancel-subscription-modal')
        "
      />
    </template>
  </div>
</template>

<script>
import { formatSubDate } from '@/helpers'
import ActionLoader from '@/components/shared/ActionLoader.vue'
import InformCancellation from './cancel-subscription-renewal-modal/InformCancellation.vue'
import ConfirmCancellation from './cancel-subscription-renewal-modal/ConfirmCancellation.vue'
import CancellationSuccess from './cancel-subscription-renewal-modal/CancellationSuccess.vue'

export default {
  name: 'CancelSubscriptionRenewalModal',
  components: {
    ActionLoader,
    InformCancellation,
    ConfirmCancellation,
    CancellationSuccess,
  },
  props: {
    subscription: {
      type: Object,
      required: true,
    },
    cancellationFields: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isLoading: false,
      steps: ['inform', 'confirm', 'success'],
      currentStep: 'inform',
    }
  },
  computed: {
    planExpiryDate() {
      const {
        subscription: { expires_at },
      } = this
      return formatSubDate(expires_at)
    },
  },
  methods: {
    async handleCancelSubscription(payload) {
      this.isLoading = true
      try {
        const {
          subscription: { id },
        } = this
        await this.$store.dispatch('subscriptions/cancelSubscription', id)
        this.$store.dispatch('subscriptions/sendCancellationResponses', payload)
        this.currentStep = this.steps[this.steps.length - 1]
        this.isLoading = false
      } catch (error) {
        this.isLoading = false
      }
    },
  },
  async created() {
    const body = document.querySelector('body')
    body.classList.add('modal-open')
    this.isLoading = true
    await this.$store.dispatch('subscriptions/getCancellationFields')
    this.isLoading = false
  },
  destroyed() {
    const body = document.querySelector('body')
    body.classList.remove('modal-open')
  },
}
</script>

<style lang="scss">
.cancel-subscription {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99999;
  width: 100%;
  height: 100%;
  background-color: rgba(113, 113, 113, 0.8);
  transition: opacity 0.3s ease;
  &__wrapper {
    display: flex;
    flex-wrap: wrap;
    position: relative;
    top: 0;
    margin: 0 auto;
    background-color: rgba(17, 17, 17, 1);
    color: var(--white);
    width: 100%;
    min-height: 410px;
    border-radius: 24px;
    overflow: scroll;
    @include tablet {
      top: 5%;
      max-width: 600px;
      min-height: 368px;
      height: auto;
    }
    @include desktop {
      overflow: hidden;
    }
    @media screen and (max-height: 800px) {
      overflow: scroll !important;
    }
  }
  &__loader {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 410px;
  }
}
</style>
